import React, { useContext } from 'react';
import { Autocomplete, Button } from '@mui/material';
import parse from 'autosuggest-highlight/parse';
import { PlaceType, PlaceTypeWithLocation, useAppState } from '../../../states/app-state';
import { googleMap } from '../../../api/google-map-api';
import styles from './AddressField.module.scss'; // added by Bearer Web Developer
import { AccessingFeatureMenuContext } from '../../../states/contexts/accessingFeatureMenu'; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer
type IColorStyle = "blue" | "gray" | "white"; // added by Bearer Web Developer
// colorStyle, handleFavouritePlaces in the following added by Bearer Web Developer
const AddressField: React.FC<{ onChange: (value: PlaceTypeWithLocation | null) => void, value: PlaceType | null, name?: string, colorStyle?: IColorStyle, handleFavouritePlaces?: () => void }> = ({ value, name, onChange, colorStyle, handleFavouritePlaces }) => {

    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<PlaceType[]>([]);
    const handleStartSession = () => {
        googleMap.startSession();
    }

    const handleFinishSession = () => {
        googleMap.finishSession();
    }

    const handleChange = async (value: PlaceType | null) => {
        if (value?.place_id) {
            const location = await googleMap.fetchPlaceDetails(value.place_id);
            if (location) {
                // const withLocation = { ...value, location }
                // setOptions((options) => {
                //     return options;
                // });
                // onChange(withLocation);

                value.location = location;
                onChange(value as unknown as PlaceTypeWithLocation);
            }
        }
    }

    React.useEffect(() => {
        let active = true;

        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        if (!googleMap.hasSession()) {
            return;
        }

        const { signal, cancel } = createCancellableSignal();

        (async () => {
            const results = await cancellableFetch(inputValue, signal, 500);
            if (!results) return;
            if (active) {
                let newOptions = [] as PlaceType[];

                if (value) {
                    newOptions = [value];
                }

                if (results) {
                    newOptions = [...newOptions, ...results];
                }

                setOptions(newOptions);
            }
        })();

        return () => {
            active = false;
            cancel();
        };
    }, [value, inputValue]);

    // modified by Bearer Web Developer start
    // added by Bearer Web Developer start
    const appState = useAppState();
    const { setAccessingFeatureMenuElement } = useContext(AccessingFeatureMenuContext);
    const handleFavouritePlacesfunction = (event: React.MouseEvent<HTMLButtonElement>) => {

        if (!appState.login.loggedin) {
            setAccessingFeatureMenuElement(event?.currentTarget);

        } else if (handleFavouritePlaces) handleFavouritePlaces();
    }
    const themeColor = colorStyle === 'gray' ? styles?.gray : colorStyle === 'white' ? styles?.white : styles.blue;
    // added by Bearer Web Developer end
    return (
        <>
            <div className={styles.header}>
                <label className={themeColor} htmlFor={name}>Address</label>
                {
                    handleFavouritePlaces &&
                    <Button className={`${styles.favourite_places} ${(colorStyle === 'blue' || !colorStyle) ? styles.favourite_places_blue : ''}`} onClick={handleFavouritePlacesfunction} >
                        <div className={styles.image}>
                            <img src="/bookmark.webp" alt="" width={18} height={18} />
                        </div>
                        <span className={styles.text}>Saved Places</span>
                    </Button>
                }
            </div>
            <Autocomplete
                id={name}
                getOptionLabel={option => option.description}
                filterOptions={x => x}
                options={options}
                autoComplete
                includeInputInList
                filterSelectedOptions
                value={value}
                onFocus={handleStartSession}
                onBlur={handleFinishSession}
                onChange={(event: any, newValue: PlaceType | null) => {
                    setOptions(newValue ? [newValue, ...options] : options);
                    handleChange(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                // added by Bearer Web Developer start
                slotProps= {{
                    paper: { sx: { borderRadius: 5, overflow: 'visible' } },
                    listbox: { sx: { borderRadius: 5 } }
                }}
                // added by Bearer Web Developer end
                classes={{
                    listbox: `${styles.items_list_group} ${themeColor}`,
                    noOptions: `${styles.items_list_group} ${themeColor}`,
                    endAdornment: styles.end_adornment,
                    popupIndicator: (colorStyle === 'blue' || !colorStyle) ? styles.popup_indicator_blue : styles.popup_indicator_white_and_gray,
                    
                }}
                noOptionsText={
                    <div className={`${styles.items_list_group} ${themeColor}`}>Type an Address ...</div>
                }
                // renderInput modified by Bearer Web Developer start
                renderInput={(params) => (
                    <div ref={params.InputProps.ref}
                        className={`${styles.autocomplete_input} ${themeColor}`}>
                        <input name={name || ''} className='active:bg-black w-full'
                            placeholder={"e.g., 447 Collins Street, Melbourne VIC 3000"} {...params.inputProps}
                        />
                        {params.InputProps.endAdornment}
                        {/* <img src='/expand-address.png' onClick={handleStartSession} /> */}
                    </div>
                )}
                // renderInput modified by Bearer Web Developer end
                // renderOption modified by Bearer Web Developer start
                renderOption={(props, option) => {
                    const matches = option.structured_formatting?.main_text_matched_substrings;
                    const parts = option.structured_formatting && matches && parse(
                        option.structured_formatting.main_text,
                        matches.map((match: any) => [match.offset, match.offset + match.length]),
                    );

                    return (
                        <li  {...props} className={`${styles.items_list} ${themeColor}`} key={option.place_id}>
                            <div>
                                <img src={(colorStyle === 'blue' || !colorStyle) ? "/location-white.png" : "/location-gray.svg"} alt="" />
                            </div>
                            <div>
                                {parts && parts.map((part, index) => (
                                    <span key={index}>{part.text}</span>
                                ))}
                                <p>
                                    {option.structured_formatting && option.structured_formatting.secondary_text}
                                    {!option.structured_formatting && option.description}
                                </p>
                            </div>
                        </li >
                    );
                }}
            // renderOption modified by Bearer Web Developer end
            />
        </>
    );
    // modified by Bearer Web Developer end
}


export default AddressField;
// export default GoogleApiWrapper({
//     apiKey: (process.env.REACT_APP_GOOGLEMAPAPI || "")
// })(AddressField)

function cancellableFetch(input: string, signal: Promise<void>, ms: number) {
    return new Promise<PlaceType[] | undefined>((res, rej) => {
        const timeOut = setTimeout(() => {
            googleMap.fetchAutocomplete(input).then((result) => {
                res(result);
            });
        }, ms);

        signal.catch(() => {
            res(undefined);
            clearTimeout(timeOut);
        });
    });
}

function createCancellableSignal(): { signal: Promise<void>, cancel: () => void } {
    const ret: any = {};
    ret.signal = new Promise((resolve, reject) => {
        ret.cancel = () => {
            reject(new Error("Promise was cancelled"));
        };
    });
    return ret;
}

